import React from 'react';
import { Box, Typography } from '@mui/material';

interface NumeroInternoMetaProps {
  nro?: number | null;
  /** Etiqueta a la izquierda. Default: "Número interno". */
  label?: string;
  /** Si se informa, se muestra en lugar de `nro` (p. ej. letra-sucursal-número). */
  valor?: string | null;
}

/** Identificador al pie del comprobante, alineado a la derecha. */
const NumeroInternoMeta: React.FC<NumeroInternoMetaProps> = ({ nro, label, valor }) => {
  const texto =
    valor != null && String(valor).trim() !== ''
      ? String(valor).trim()
      : Number(nro) > 0
        ? String(nro)
        : '—';
  const etiqueta = (label ?? 'Número interno').trim() || 'Número interno';

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, pt: 1.5 }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {etiqueta}{' '}
        <Box
          component="span"
          sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.875rem' }}
        >
          {texto}
        </Box>
      </Typography>
    </Box>
  );
};

export default NumeroInternoMeta;
